import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SuspenseLoader from 'src/components/SuspenseLoader';
import UsuarioForm from './content/management/UsuarioForm';
import UsuarioFormValidacao from './content/management/UsuarioFormValidacao';
import UsuarioEditForm from './content/management/UsuarioEditForm';
import UsuarioFormEditValidacao from './content/management/UsuarioFormEditValidacao';
import SidebarLayout from './layouts/SidebarLayout';
import Login from './content/Login';
import PrivateRoute from './privateRoute';

// Lazy loading de componentes
const Loader = (Component) => (props) => (
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

// Páginas

// Management
const UsersList = Loader(lazy(() => import('src/content/management/UsersList')));

// Dashboards



// Rotas
const routes: RouteObject[] = [
  // Login
  {
    path: "login",
    element: <Login />
  },
  {
    path: "/",
    element: <Login />
  },
  {
    path: 'management',
    element: <PrivateRoute />, // Protegendo com PrivateRoute
    children: [
      {
        path: '',
        element: <SidebarLayout />,
        children: [
          { path: '', element: <Navigate to="user-list" replace /> },
          { path: 'user-list', element: <UsersList /> },
          { path: 'new-user', element: <UsuarioForm /> },
          { path: 'edit-user/:id', element: <UsuarioEditForm /> },
        ],
      },
    ],
  },
];

export default routes;
